import React from 'react';
import {iconName, qualify} from '@packages/systems/wfdl-Qualified';

import {Atom, Plugins} from '@packages/systems/wfdl';
import {createIntegratedAtom} from '@packages/utilities/integrated-types';

const CommerceCartCloseLinkIcon = Atom.createRender(
  ({attributes, classes, generateAttributes}) => {
    return (
      <svg
        {...generateAttributes(attributes, classes)}
        width="16px"
        height="16px"
        viewBox="0 0 16 16"
      >
        <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
          <g fillRule="nonzero" fill="#333333">
            <polygon points="6.23223305 8 0.616116524 13.6161165 2.38388348 15.3838835 8 9.76776695 13.6161165 15.3838835 15.3838835 13.6161165 9.76776695 8 15.3838835 2.38388348 13.6161165 0.616116524 8 6.23223305 2.38388348 0.616116524 0.616116524 2.38388348 6.23223305 8" />
          </g>
        </g>
      </svg>
    );
  }
);

const config = createIntegratedAtom({
  displayName: 'Icon',
  showEmpty: false,
  icon: {
    type: 'Component',
    value: qualify(Plugins.name('Basic'), iconName('Star')),
  },
  render: CommerceCartCloseLinkIcon,
  fields: {},
});

export default config;
